import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { environment } from './../../../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class ServiceCallSummaryService {

  private urlPrefix: string = environment.appUrl;

  constructor(
    private http: HttpClient
  ) { }

  getSummary(startDate, endDate, arranging, confirmed, completed, cancelled, all, customerId): Observable<any> {
    // change api url later
    let url;
    let prefix;
    if (all) {
      prefix = 'service-calls?';
    } else {
      prefix = 'customers/' + customerId + '/service-call-summary?';
    }
    url = this.urlPrefix + prefix + 'start-date=' + startDate + '&end-date=' + endDate
    + '&arranging=' + arranging + '&confirmed=' + confirmed + '&finished=' + completed + '&cancelled=' + cancelled;

    return this.http
      .get(url, {
          observe: 'response'
      })
      .map(
        res => {
          if (res.status === 200) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/service-call/service-call-summary/service-call-summary.service.ts